const modalChangePassword = {
  header: 'Kennwort ändern',
  currentPassword: 'Aktuelles Passwort',
  newPassword: 'Neues Passwort',
  confirmPassword: 'Passwort bestätigen',
  buttonSubmit: 'Bestätigen',
  validation: {
    required: 'Passwort erforderlich',
    leastCharacters: 'Das Passwort muss mindestens 6 Zeichen lang sein',
    criteria: 'Sollte Klein- und Großbuchstaben enthalten',
    mustMatch: 'Passwörter müssen übereinstimmen',
    confirmRequired: 'Passwort bestätigen ist erforderlich',
  },
};

export default modalChangePassword;
